import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { TextLink } from "@root/shared/components/TextLink";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

type Props = {
  inquiryUrl: string;
};

export const GuidanceBoxForReopenCreate: FC<Props> = ({ inquiryUrl }) => {
  return (
    <GuidanceBox themeColor="pink" className={styles.box}>
      <>
        <p className={styles.about}>
          <span className={styles.iconBox}>
            <Icon name="information" color={colors.Biyo} />
          </span>
          再開のご申請に関して
        </p>
        <p className={styles.detail}>
          契約期間は30日ごとの自動更新になります。
          <br />
          他に、応募効果アップの特典がついてくる360日プラン・720日プランもございます。
          <br />
          ご興味のある方は、
          <TextLink
            icon={<Icon name="target-blank" />}
            href={inquiryUrl}
            target="_blank"
            className={styles.textLink}
          >
            お問い合わせフォーム
          </TextLink>
          よりご連絡ください。
        </p>
      </>
    </GuidanceBox>
  );
};
